
const Title = () => {

    const title = "Repository Quickview";

    return ( 
        <div>
            <h1 className="appTitle">
                { title }
            </h1>
        </div>
     );
}
 
export default Title;